import { Today } from "features/today/components/Today";

export default function Home() {
  return <Today />;
}
